import React, { useState } from 'react'
import { CombinedGraphQLErrors } from '@apollo/client'
import { useLazyQuery } from '@apollo/client/react'
import { Button, Separator, Toggle, ToggleGroup } from '@fs/zion-ui'
import { NoticeLoading } from '@fs/zion-icon'

import { useGroupData } from '../../../../hooks'
import queries from '../../../../queries'
import styles from './ReprocessFolder.styles'
import transl from './ReprocessFolder.transl'

export default function ReprocessFolder({ requested, setRequested, setDuplicateRequest }) {
  const [crop, setCrop] = useState(true)
  const [deskew, setDeskew] = useState(true)
  const [sharpen, setSharpen] = useState(true)

  const [loading, setLoading] = useState(false)

  const {
    group: { metadata = {} },
  } = useGroupData()
  const [reprocessRequest] = useLazyQuery(queries.reprocessRequest(), {
    errorPolicy: 'all',
  })

  const handleClick = async () => {
    setLoading(true)
    const { error: requestError } = await reprocessRequest({
      variables: { imageGroupNumber: metadata.imageGroupNumber, crop, deskew, sharpen },
    })

    let errorMessage = false
    if (CombinedGraphQLErrors.is(requestError)) {
      errorMessage = requestError.errors.some(({ message }) => message.includes('409'))
    }

    if (errorMessage === true) {
      setDuplicateRequest(true)
      setRequested(false)
    } else {
      setRequested(true)
    }
    setLoading(false)
  }

  return (
    <div css={styles.reprocessFolder}>
      <ToggleGroup orientation="vertical" label={transl.reprocessOperations()}>
        <div css={styles.reprocessFolder}>
          <Toggle
            label={transl.crop()}
            name="crop"
            checked={crop}
            onChange={() => {
              setCrop(!crop)
            }}
            disabled={requested}
          />
          <Toggle
            label={transl.deskew()}
            name="deskew"
            checked={deskew}
            onChange={() => {
              setDeskew(!deskew)
            }}
            disabled={requested}
          />
          <Toggle
            label={transl.sharpen()}
            name="sharpen"
            checked={sharpen}
            onChange={() => {
              setSharpen(!sharpen)
            }}
            disabled={requested}
          />
        </div>
      </ToggleGroup>
      <Separator size="xxs" />

      <div css={styles.reprocessFolderButton}>
        <Button
          emphasis="medium"
          disabled={loading || requested}
          onClick={() => handleClick()}
          Icon={loading ? NoticeLoading : null}
        >
          {requested ? transl.requestSubmitted() : transl.reprocessFolder()}
        </Button>
      </div>
      {/* {requested && <Paragraph size="sm">{transl.requestSubmitted()}</Paragraph>} */}
    </div>
  )
}
